var o=function(){return"function"==typeof Promise&&Promise.prototype&&Promise.prototype.then};export{o as c};
